<template>
  <div>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Lista Attività </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="dialog_nuovo = true" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Nuovo</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Vai alla dashboard</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      height="60vh"
      fixed-header
      :headers="headers"
      :items="items_visualizzati"
      ><!-- Colonna della selezione -->
      <template v-slot:[`item.seleziona`]="{ item }">
        <v-btn
          @click="
            dialog_nuovo = true;
            selezionato = item;
            assegnaCampi();
          "
          small
          ><v-icon color="primary">mdi-pencil</v-icon></v-btn
        >
      </template>
      <!-- Colonna data creazione -->
      <template v-slot:[`item.data_creazione`]="{ item }">
        {{ formatData(item.data_creazione) }}
      </template>
      <!-- Colonna data scadenza -->
      <template v-slot:[`item.data_scadenza`]="{ item }">
        {{ formatData(item.data_scadenza) }}
      </template>
      <!-- Colonna del delete -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-btn
          @click="
            deleteTask(item);
            selezionato = item;
          "
          small
          v-model="item.cancellato"
          ><v-icon color="error">mdi-delete</v-icon></v-btn
        >
      </template>
    </v-data-table>

    <!-- DIALOG NUOVO -->
    <v-dialog v-model="dialog_nuovo" max-width="600px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title v-if="selezionato == null">Crea</v-toolbar-title>
          <v-toolbar-title v-if="selezionato != null">Modifica</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salva" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_nuovo = false;
                  cleanVariabili();
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-0">
          <v-row align="center" justify="center">
            <v-col cols="5">
              <v-text-field v-model="task.titolo" type="text" label="Titolo" />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="task.data_scadenza"
                type="date"
                label="Scadenza"
              />
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-2"
                    @click="gestione_allegato = true"
                    small
                    :disabled="task.id_task == -1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-paperclip</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi allegato</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-textarea
                v-model="task.des"
                type="text"
                outlined
                label="Descrizione"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-overlay
          color="rgba(0, 0, 0, 1)"
          style="position: absolute"
          :value="caricamento_dati"
        >
          <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
          <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
        </v-overlay>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="gestione_allegato"
      width="60%"
      persistent
      style="background-color: blue"
    >
      <GestioneAllegato
        v-if="selezionato != null"
        @click_chiudi="gestione_allegato = false"
        @salva_allegati="salvaAllegati"
        :show_save_button="true"
        controller_allegati="Global"
        :id_riferimento="selezionato.id_task"
        ref="componenteAllegati"
        :show_close="true"
        tipo_allegato="ATTIVITA"
        :toolbar_title="'Allegati attività'"
      />
    </v-dialog>
  </div>
</template>

<script>
//import Gestione allegati from '@vue/composition-api'
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import moment from "moment/moment";

export default {
  components: { SnackbarQV, GestioneAllegato },
  data() {
    return {
      //Modali
      // Sia per nuovo che modifica
      dialog_nuovo: false,
      dialog_conferma_elimina: false,
      caricamento_dati: false,
      gestione_allegato: false,

      // Variabili di supporto
      selezionato: null,
      task: {
        id_task: -1,
        titolo: "",
        des: "",
        data_creazione: "",
        data_scadenza: "",
        allegati: "",
      },

      //Array
      headers: [
        { text: "Modifica", value: "seleziona" },
        { text: "Titolo", value: "titolo", type: "string" },
        { text: "Descrizione", value: "des", type: "string" },
        { text: "Data creazione", value: "data_creazione", type: "date" },
        { text: "Scadenza", value: "data_scadenza", type: "date" },
        { text: "Allegati", value: "allegati" },
        { text: "Cancella", value: "delete" },
      ],
      items_visualizzati: [],
      lista: [],
    };
  },
  mounted() {
    this.getListaAttivita();
  },
  watch: {
    lista: {
      immediate: true,
      handler() {
        this.items_visualizzati = this.lista;
        //this.filtra();
      },
    },
  },
  methods: {
    assegnaCampi() {
      console.log(this.selezionato.id_task);
      this.task.id_task = this.selezionato.id_task;
      this.task.titolo = this.selezionato.titolo;
      this.task.des = this.selezionato.des;
      this.task.data_scadenza = this.formatData(this.selezionato.data_scadenza);
      console.log(this.data_scadenza);
    },

    cleanVariabili() {
      this.task = {
        id: -1,
        titolo: "",
        des: "",
        data_creazione: "",
        data_scadenza: "",
        allegati: "",
      };
      this.task.id_task = -1;
      this.selezionato = null;
    },

    clickIndietro() {
      this.$router.push("/home/dashboard");
    },

    deleteTask(arg) {
      arg.validita = 0;
      let request = {
        controller: "ListaAttivita",
        method: "PUT",
        richiesta: {
          action: "setattivita",
          token: localStorage.getItem("user_token"),
          task: arg,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          this.lista = res.data.lista;
          this.$refs.SnackbarQV.print("success", "Eliminazione effettuata.");
        })
        .catch((error) => {
          console.log(error);
        });

      this.selezionato = null;
    },

    formatData(data) {
      if (data != null) {
        data = data.split("T");
        return data == null || data[0] == ""
          ? "N/D"
          : moment(data[0]).format("YYYY-MM-DD");
      }
    },
    getListaAttivita() {
      this.caricamento_dati = true;

      let request = {
        controller: "ListaAttivita",
        method: "POST",
        richiesta: {
          action: "getlistaattivita",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.caricamento_dati = false;
        this.lista = res.data.lista;
      });
    },

    salva() {
      this.caricamento_dati = true;
      if (this.selezionato == null) {
        // Task nuovo
        this.task.data_creazione = new Date();
        this.task.id_task = -1;
        this.task.validita = 1;
      } else {
        this.task.id_task = this.selezionato.id_task; // Modifico task - aggiugere chiamata modifica
        this.task.data_creazione = this.selezionato.data_creazione;
        this.task.validita = 1;
      }

      let request = {
        controller: "ListaAttivita",
        method: "PUT",
        richiesta: {
          action: "setattivita",
          token: localStorage.getItem("user_token"),
          task: this.task,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          this.lista = res.data.lista;
          this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");
        })
        .catch((error) => {
          console.log(error);
        });

      this.cleanVariabili();
      this.dialog_nuovo = false;
    },

    salvaAllegati() {
      this.$refs.componenteAllegati.salvaTuttiAllegati();
      this.gestione_allegato = false;
    },
  },
};
</script>


